var $2f008f619b8c5b27$exports = {};
$2f008f619b8c5b27$exports = {
    "breadcrumbs": `\u{D0D0}\u{C0C9} \u{D45C}\u{C2DC}`
};


export {$2f008f619b8c5b27$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
